<ejs-schedule
    (actionComplete)="onActionComplete($event)"
    (cellClick)="onCellClick($event)"
    (eventClick)="onEventClick($event)"
    (eventRendered)="onEventRendered($event)"
    (popupOpen)="onPopupOpen($event)"
    [dateFormat]="dateFormat"
    [eventSettings]="events()"
    [firstDayOfWeek]="1"
    [group]="resourceGroup()"
    [selectedDate]="selectedDate"
    [showQuickInfo]="showQuickInfo"
    [timeFormat]="timeFormat"
    [workHours]="workHours()"
    height="100%"
    locale="de-CH"
    width="100%"
>
    <e-views>
        <e-view [endHour]="rasterEnd()" [startHour]="rasterStart()" option="Agenda"></e-view>
        <e-view [endHour]="rasterEnd()" [startHour]="rasterStart()" option="TimelineWeek"></e-view>
        <e-view [endHour]="rasterEnd()" [startHour]="rasterStart()" option="TimelineMonth"></e-view>
        <e-view [endHour]="rasterEnd()" [startHour]="rasterStart()" option="Week"></e-view>
        <e-view [endHour]="rasterEnd()" [startHour]="rasterStart()" isSelected="true" option="WorkWeek"></e-view>
        <e-view [showWeekend]="showWeekend" option="Month"></e-view>
    </e-views>
    <e-resources>
        <e-resource
            [allowMultiple]="allowMultiple"
            [dataSource]="resources()"
            colorField="Farbe"
            field="UserName"
            idField="UserName"
            name="Mitarbeiter"
            textField="Mitarbeiter"
            title="Mitarbeiter"
        ></e-resource>
    </e-resources>
</ejs-schedule>
